import styled from 'styled-components';

const SecondaryNavTitle = styled.div<{
  activeStyle: Record<string, any>;
  isActive?: (_: any, location: Location) => boolean;
}>`
  color:
    ${({ activeStyle, isActive }) => (
    activeStyle?.color && isActive && isActive(null, window.location)
      ? activeStyle.color
      : '#484848'
  )};
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  word-break: keep-all;
`;

export default SecondaryNavTitle;
